/*
    Third panel in Overview showing historically printed models
 */
import React from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    changeSearchEmail, clearModelInfolist,
    clearError,
    startSearchingPrintRecords,
    searchPrintRecordsByEmail, initloadingAndHasMore,
    searchPrintRecordsByEmailWithinSpanThenAppendOrOverride,
    
    updateToggleListOfPrintItems
} from "../actions/getPrintedModels";
import GenericPanel from "../components/generic_panel";
import CurrentStatusSection, { DisplayedStatusByPrinterStatusType } from './current_status_section';
import PrintsItem from '../components/prints-item';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import '../css/prints-panel.css';
import { closeLightbox, openLightbox } from "../actions/lightbox";
import Lightbox from "react-image-lightbox";
import LoadingAnimation from "../components/loading-animation";

class printRecordPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDateFiltered: false,
            endDateFiltered: false,
            startDateInputFocused: false,
            endDateInputFocused: false
        }
    }

    async componentWillMount() {
        this.props.initloadingAndHasMore()
    }

    async showPrintRecordList() {
        const email = this.props.email.trim();
        if (email === '') return;
        this.props.clearError()
        await this.props.searchPrintRecordsByEmail()
        const promiseOfRefresh = this.getPrintRecordsList(Date.now(), email, false);
        if (!promiseOfRefresh) return;
        promiseOfRefresh.then(this.initToggleListOfPrintRecordItems.bind(this));
    }

    clearPrintRecordList() {
        const promiseOfRefresh = []
        promiseOfRefresh.then(this.initToggleListOfPrintRecordItems.bind(this));
    }

    getPrintRecordsList(endTimeStamp, email, willBeAppendedToList) {
        if (!this.props.hasMore) return;
        try {
            return this.props.searchPrintRecordsByEmailWithinSpanThenAppendOrOverride(endTimeStamp, email, willBeAppendedToList);
        } catch (err) {
            console.log(err.message);
        }
    }

    initToggleListOfPrintRecordItems() {
        const allRecordsOfPrints = this.props.printedModels;
        const tempToggleList = [...this.props.togglesOfPrintRecordItems];
        allRecordsOfPrints.map(payload => {
            tempToggleList.push(false);
        })
        this.props.updateToggleListOfPrintItems(tempToggleList);
    }

    render() {
        const { closeLightbox, lightboxSrc, isLightboxOpen } = this.props;
        if (this.props.error.status === 401) {
            return  <Redirect to={{
                pathname: '/cstLogin',
                state: { errorMessage: 'Account verification failed, no permission' }
            }} />
        }
        return (
            <div style={{ width:'70%' }}>
                {isLightboxOpen &&
                    <Lightbox mainSrc={lightboxSrc} onCloseRequest={closeLightbox} />}
                {this.filtersOfPrints()}
                <InfiniteScroll
                    pageStart={0}
                    threshold={0}
                    loadMore={this.handleInfiniteLoad.bind(this)}
                    hasMore={this.props.hasMore && !this.props.loading}
                >
                    {this.loadListOfPrints()}
                </InfiniteScroll>
            </div>
        );
    }

    filtersOfPrints() {
        return <div className='filter-container'>
            <form className='model-name-filter' onSubmit = { e => {e.preventDefault()} }>
                <input
                    placeholder='Please input the email address...'
                    type="text"
                    onChange={(e) => {
                        const email = e.target.value;
                        this.props.changeSearchEmail(email);
                    }}
                    onKeyUp={(e) => {
                        e.preventDefault
                        if (e.keyCode === 13 && e.target.value) {
                            this.props.startSearchingPrintRecords();
                            this.showPrintRecordList();
                        }
                    }}
                    value={this.props.email}
                />
                {this.props.email ?
                    <i className="material-icons search-clear-ctn"
                        onClick={() => {
                            this.props.clearModelInfolist();
                        }}
                    >clear</i> : <i className="material-icons search-clear-ctn">search</i>}
            </form>
        </div>
    }

    loadListOfPrints() {
        const listOfPrintedModels = this.props.printedModels;
        const printsListByDate = this.dividePrintsByDate(listOfPrintedModels);


        if (this.props.error.status === 400) {
            return <div>{this.props.error.data.message}</div>
        }

        return <div>
            {printsListByDate}
            {this.props.loading ? <LoadingAnimation /> : null}
        </div>;
    }

    dividePrintsByDate(listOfPrintRecords) {
        if (!listOfPrintRecords) return [];

        const itemClustersByDates = this.getItemClustersByDates(listOfPrintRecords);
        const recordCardsByDates = itemClustersByDates.map((recordClusterByDate, indexOfCluster) => {
            const dateLiteral = Object.keys(recordClusterByDate)[0];
            return <GenericPanel
                title={this.formattedCardHeaderFromDate(new Date(dateLiteral))}
                key={indexOfCluster}
            >
                {recordClusterByDate[dateLiteral]}
            </GenericPanel>
        })
        return (
            <div>
                {recordCardsByDates}
            </div>
        )
    }

    getItemClustersByDates(listOfPrintRecords) {
        let ItemClustersByDates = [];
        let tempClusterOfPrintsItems = [];
        let printDateOfLastRecord = new Date();

        listOfPrintRecords.forEach((recordOfPrint, index) => {
            const { timeStamp, modelName } = recordOfPrint;
            const printDate = new Date(timeStamp);
            if (this.isSameDay(printDate, printDateOfLastRecord)) {
                tempClusterOfPrintsItems.push(this.getPrintsItem(recordOfPrint, index));
            } else {
                this.addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord);
                tempClusterOfPrintsItems = [this.getPrintsItem(recordOfPrint, index)];
                printDateOfLastRecord = printDate;
            }
        });
        this.addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord);
        return ItemClustersByDates;
    }

    isSameDay(date1, date2) {
        return moment(date1).isSame(date2, 'day');
    }

    getPrintsItem(recordOfPrint, index) {
        const { openLightbox } = this.props;
        const { compositeScope, jobId } = recordOfPrint;
        const previewFileName = `${compositeScope}@${jobId}.png`;

        return <PrintsItem
            {...recordOfPrint}
            printerName={recordOfPrint.printerName}
            key={index}
            index={index}
            expanded={this.props.togglesOfPrintRecordItems[index]}
            displayedStatus={DisplayedStatusByPrinterStatusType[recordOfPrint.status]}
            previewFileName={previewFileName}
            openLightbox={openLightbox}
        />
    }

    addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord) {
        if (tempClusterOfPrintsItems.length === 0) return;

        ItemClustersByDates.push({ [printDateOfLastRecord]: tempClusterOfPrintsItems });
    }

    formattedCardHeaderFromDate(date) {
        let dayIndicator = '';
        const today = new Date();
        const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
        if (this.isSameDay(today, date)) {
            dayIndicator = 'Today';
        } else if (this.isSameDay(yesterday, date)) {
            dayIndicator = 'Yesterday';
        } else {
            dayIndicator = moment(date).format("dddd");
        }
        let formattedDate = moment(date).format("LL");
        return `${dayIndicator}, ${formattedDate}`;
    }

    handleInfiniteLoad() {
        const { timeStampOfBottomRecord, email } = this.props;
        this.getPrintRecordsList(timeStampOfBottomRecord - 1, email, true);
    }
}

const mapStateToProps = state => ({
    ...state.printedModels,
    userProfile: state.userProfile,
    isLightboxOpen: state.lightbox.isLightboxOpen,
    lightboxSrc: state.lightbox.src
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        searchPrintRecordsByEmailWithinSpanThenAppendOrOverride,
        updateToggleListOfPrintItems,
        openLightbox,
        closeLightbox,
        changeSearchEmail,
        clearModelInfolist,
        searchPrintRecordsByEmail,
        initloadingAndHasMore,
        clearError,
        startSearchingPrintRecords
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(printRecordPanel);


// WEBPACK FOOTER //
// ./src/containers/print-record-panel.js